import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=b3b85184&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"
import "./RichText.vue?vue&type=style&index=0&id=b3b85184&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b85184",
  null
  
)

export default component.exports